<template>
  <!-- if click on a rubric the liste of page appears, if click on a page the list of capa appear (accumulation of elements) -->
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div>
          <strong>
            <i class="icon-note"></i>
            Capabilities for Group Name: {{groupName}}
          </strong>
          {{group_id_title}}
        </div>
        <b-button-group>
          <router-link :to="'/settings/group/edit/'">
            <b-button class="custom-cancel">
              <i class="fa fa-times text-danger"></i>
              &nbsp;Cancel
            </b-button>
          </router-link>
          <b-button v-on:click="post('andClose')">
            <i class="fa fa-save"></i>&nbsp;Save & Close
          </b-button>
          <b-button v-on:click="post()">
            <i class="fa fa-check text-success"></i>&nbsp;Apply
          </b-button>
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-row v-if="items!=null">
          <b-col md="12">
            <b-form v-on:submit.prevent="onSubmit" novalidate>
              <b-form-group >
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                  <ul>
                    <li class="li-custom" v-for="item in items" :key="item.id">
                      <div class="custom-control custom-checkbox">
                        <input
                          @change="handleChange(item)"
                          type="checkbox"
                          class="custom-control-input"
                          :id="item.name"
                          :value="item.name"
                          v-model="selectedNavs"
                        />
                        <label class="custom-control-label" :for="item.name">
                          <i :class="'' + item.icon + ' nav-icon font-sl d-inline-block'"></i>
                          {{item.name}}
                        </label>
                      </div>
                    </li>
                  </ul>
                </b-form-checkbox-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form v-on:submit.prevent="onSubmit" novalidate>
              <b-form-group >
                <div v-for="item in items" :key="item.id">
                  <b-card v-if="item.children!=null && item.visible === true">
                    <div slot="header">
                      <i :class="'' + item.icon + ' nav-icon font-sl d-inline-block'"></i>
                      {{item.name}}
                    </div>
                    <b-form v-on:submit.prevent="onSubmit" novalidate>
                      <b-form-group >
                        <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                          <ul>
                            <li class="li-custom" v-for="child in item.children" :key="child.id">
                              <div class="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  :id="child.name"
                                  :value="child.name"
                                  v-model="selectedNavsChild"
                                />
                                <label class="custom-control-label" :for="child.name">{{child.name}}</label>
                              </div>
                            </li>
                          </ul>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </b-form>

                    <div v-for="child in item.children" :key="child.id">
                      <b-card v-if="child.visible === true">
                        <div slot="header">
                          <i :class="'' + child.icon + ' nav-icon font-sl d-inline-block'"></i>
                          {{child.name}}
                        </div>
                        <b-form v-on:submit.prevent="onSubmit" novalidate>
                          <b-form-group >
                            <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                              <ul>
                                <li
                                  class="li-custom"
                                  v-for="capa in child.capabilities"
                                  :key="capa.id"
                                >
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      :id="capa.name"
                                      :value="capa.name"
                                      v-model="selectedCapabilities"
                                    />
                                    <label
                                      class="custom-control-label"
                                      :for="capa.name"
                                    >{{capa.label}}</label>
                                  </div>
                                </li>
                              </ul>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-form>
                      </b-card>
                    </div>
                  </b-card>
                </div>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import Vue from "vue";
import nav from "../../_nav.js";
import { router } from "../../router/index";
import { apigClient } from "@/shared/api";
import { Switch as cSwitch } from "@coreui/vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Modals from "@/shared/Modals.vue";

const Spinner = () => import("../shared/Spinner");
// nav[0].children = [
//   {
//     icon: "icon-puzzle",
//     name: "Dashboard page",
//     capabilities:[{id:2, name:"capa 1"}, {id:3, name:"capa 2"}]
//   },
// ];

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);

var capabilitiesJson = [];
let user = JSON.parse(localStorage.getItem("loginUserInfo"));

//Export component
export default {
  name: "GroupCapabilities",
  components: {
    Event,
    cSwitch,
    Spinner,
    Modals
  },
  data: function() {
    var loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    var group_id = localStorage.getItem('page_group_id');
    return {
      isLoading: true,
      items: [],
      selectedNavs: [],
      selectedNavsChild: [],
      selectedCapabilities: [],
      useVuex: false,
      groupName: null,
      description: null,
      group_id: group_id || null,
      group_id_title: group_id ? " (id:" + group_id + ")" : ""
    };
  },
  watch: {
    selectedNavs: function(newVal, oldVal) {
      var that = this;
      // We make the selected category visible
      this.items = this.items.map(item => {
        item.visible = newVal.indexOf(item.name) >= 0;
        return item;
      });
      //if we unselect an item we must remove the pages of this item from the list this.selectedNavsChild
      if (newVal.length < oldVal.length) {
        var diff = oldVal.filter(function(i) {
          return newVal.indexOf(i) < 0;
        });
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].name == diff && this.items[i].children) {
            for (let j = 0; j < this.items[i].children.length; j++) {
              this.selectedNavsChild = this.selectedNavsChild.filter(function(
                value
              ) {
                return value != that.items[i].children[j].name;
              });
            }
            break;
          }
        }
      }
      //Apply newVal to capabilitiesJson
      this.selectedNavs = newVal;
    },
    selectedNavsChild: function(newVal, oldVal) {
      var that = this;
      // We make the selected pages visible
      if (this.items) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].children) {
            for (let j = 0; j < this.items[i].children.length; j++) {
              this.items[i].children[j].visible =
                newVal.indexOf(this.items[i].children[j].name) >= 0;
            }
          }
        }
      }
      //if we unselect a page we must remove the capa of this page from the list this.selectedCapabilities
      if (newVal.length < oldVal.length) {
        var diff = oldVal.filter(function(i) {
          return newVal.indexOf(i) < 0;
        });
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].children) {
            for (let j = 0; j < this.items[i].children.length; j++) {
              if (
                this.items[i].children[j].name == diff &&
                this.items[i].children[j].capabilities
              ) {
                for (
                  let k = 0;
                  k < this.items[i].children[j].capabilities.length;
                  k++
                ) {
                  this.selectedCapabilities = this.selectedCapabilities.filter(
                    function(value) {
                      return (
                        value != that.items[i].children[j].capabilities[k].name
                      );
                    }
                  );
                }
                break;
              }
            }
          }
        }
      }

      //Apply newVal to capabilitiesJson
      this.selectedNavsChild = newVal;
    },
    selectedCapabilities: function(newVal, oldVal) {
      //Apply newVal to capabilitiesJson
      this.selectedCapabilities = newVal;
    }
  },
  methods: {
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    post: function(option) {
      var that = this;
      this.isLoading = true;
      this.capabilitiesJson = [
        this.selectedNavs,
        this.selectedNavsChild,
        this.selectedCapabilities
      ];
      // Do PUT to API insert into Database
      this.$refs.form.openModal();
      that.changeModalContent(
        "loading",
        "Updating...",
        "Updating Group Capabilities Info"
      );
      var method = "PUT";
      var pathTemplate = "/groups/" + this.group_id + "/capabilities";
      var additionalParams = {};
      var body = {
        groupCapabilities: this.capabilitiesJson
      };
      var pathParams = {};
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result) {
          console.log("update a capabilities, group_id: " + that.group_id);
          // that.showSuccessMsgUpdate();
          that.changeModalContent(
            "success",
            "Updated success!",
            "The Group Capabilities data has been updated"
          );
          if (option == "andClose") {
            setTimeout(() => {
              router.push("/settings/group/edit/");
            }, 2000);
          } else {
            setTimeout(() => {
              router.push("/settings/group/edit/");
            }, 2000);
          }
        })
        .catch(function(result) {
          console.log(result);
          // that.showErrorMsg();
          that.changeModalContent(
            "error",
            "Error Occured!",
            " " + result.message
          );
        });
      //todo: update the group server side
      that.isLoading = false;
    },
    handleChange(item) {
      // Do what you want with the selected wallets:
    },
    getGroupData: function() {
      var method = "GET";
      var pathTemplate = "/groups/" + this.group_id;
      var additionalParams = {};
      var pathParams = {};
      var groupData = [];
      var that = this;
      that.isLoading = false;

      //to do: get json object from server
      if (nav.items) {
        this.items = nav.items.map((item, index) => {
          item.id = index;
          item.visible = false;
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              item.children[i].visible = false;
              item.children[i].id = i + 100;
            }
          }
          return item;
        });
      }

      //Default Capablities if not fetch from API.
      this.selectedNavs = ["CONNECTIONS", "COMPONENTS"];
      this.selectedNavsChild = ["Companies", "Users", "Media Library"];
      this.selectedCapabilities = ["capa 8", "capa 14", "capa 13", "capa 5"];
      //Here we fetch the server to get the group capabilities already checked for group_id
      //Then we make visible the items listed in this.selectedNavs
      if (this.items) {
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].visible =
            that.selectedNavs.indexOf(this.items[i].name) >= 0;
          if (this.items[i].children) {
            for (let j = 0; j < this.items[i].children.length; j++) {
              this.items[i].children[j].visible =
                this.selectedNavsChild.indexOf(
                  this.items[i].children[j].name
                ) >= 0;
            }
          }
        }
      }
      this.capabilitiesJson = [
        this.selectedNavs,
        this.selectedNavsChild,
        this.selectedCapabilities
      ];
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          var groupData = result["data"]["data"];
          that.groupName = groupData.groupName;
          if (groupData.groupCapabilities) {
            that.capabilitiesJson = groupData.groupCapabilities;
            that.selectedNavs = that.capabilitiesJson["0"];
            that.selectedNavsChild = that.capabilitiesJson["1"];
            that.selectedCapabilities = that.capabilitiesJson["2"];
          }
          //This is where you would put a success callback
          that.isLoading = false;
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
          that.isLoading = false;
          //This is where you would put an error callback
        });
    }
  },
  mounted: function() {
    this.isLoading = false;
    this.getGroupData();
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Capabilities has been created"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Capabilities has been updated"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "The Capabilities cannot be saved"
    }
  }
};
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style scoped>
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}

.custom-header {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }
  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.form-group {
  margin-bottom: 0;
}
</style>

<style lang="scss">
.btn-secondary {
  background-color: none;
}

.container-fluid {
  margin: 0 !important;
  padding: 0 !important;
}

.breadcrumb {
  margin-bottom: 0;
  border-bottom: 0;
}
.tab-content .tab-pane {
  padding: 0 !important;
}

// .card {
//   border:none;
// }

.li-custom {
  list-style-type: none;
  display: inline-block;
  margin: 0px 15px 9px 0px;
}
</style>
